import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { analytics } from "#/lib/analytics";

/**
 * Fires a pageview on every route change. Provider-agnostic: it goes through the
 * analytics facade, which fans out to whatever sinks are registered (Amplitude
 * today). SDK specifics (init, `page_view` mapping) live in the sink — never here.
 */
export function PageViewSync() {
	const pathname = useRouterState({
		select: (state) => state.location.pathname,
	});

	useEffect(() => {
		analytics.page(pathname);
	}, [pathname]);

	return null;
}
